// Routes de la zone /citoyen (portail citoyen, lot L1-B), toutes sous la coquille citoyenne et
// sa session usager. Raccordées dans Application.tsx par une seule ligne.
import { EtatVide, LienBouton } from '@cc/ui';
import type { RouteObject } from 'react-router';
import { EnTeteCitoyen } from './commun';
import { PageCoffre } from './compte/PageCoffre';
import { PageCompte } from './compte/PageCompte';
import { PageConnexionUsager } from './compte/PageConnexionUsager';
import { PageIdentite } from './compte/PageIdentite';
import { PageInscription } from './compte/PageInscription';
import { PageMotDePasse } from './compte/PageMotDePasse';
import { PageRepresentations } from './compte/PageRepresentations';
import { CoquilleCitoyen } from './CoquilleCitoyen';
import { PageDepot } from './depot/PageDepot';
import { PageNotifications } from './PageNotifications';
import { PageCreanceUsager } from './paiements/PageCreanceUsager';
import { PageMesAttributions } from './paiements/PageMesAttributions';
import { PageMesPaiements } from './paiements/PageMesPaiements';
import { PageMesQuittances } from './paiements/PageMesQuittances';
import { PagePaiements } from './paiements/PagePaiements';
import { PageSimulateurPaiement } from './paiements/PageSimulateurPaiement';
import { PageSuiviPaiement } from './paiements/PageSuiviPaiement';
import { PageAccueilCollectivite } from './public/PageAccueilCollectivite';
import { PageCatalogue } from './public/PageCatalogue';
import { PageDeliberation, PageDeliberations } from './public/PageDeliberations';
import { PageConsultation, PageConsultations, PageEvenementsPublics } from './participation/PagesPubliques';
import { PageMesQuartiers, PageQuartierRepresentant } from './participation/PagesQuartier';
import { PageChoixCollectivite } from './public/PageChoixCollectivite';
import { PageFicheDemarche } from './public/PageFicheDemarche';
import { PageUrbanisme } from './public/PageUrbanisme';
import { PageVerification } from './public/PageVerification';
import { PageNouveauRendezVous } from './rendez-vous/PageNouveauRendezVous';
import { PageRendezVous } from './rendez-vous/PageRendezVous';
import { PageNouvelleReclamation } from './reclamations/PageNouvelleReclamation';
import { PageMesReservations } from './reservations/PageMesReservations';
import { PageNouvelleReservation } from './reservations/PageNouvelleReservation';
import { PageReclamations } from './reclamations/PageReclamations';
import { PageNouveauSignalement } from './signalements/PageNouveauSignalement';
import { PageSignalements, PageSignalementUsager } from './signalements/PageSignalements';
import { PageComplement } from './suivi/PageComplement';
import { PageDossierUsager } from './suivi/PageDossierUsager';
import { PageMesDossiers } from './suivi/PageMesDossiers';
import { PageConversation, PageMessages } from './suivi/PageMessages';

function PageIntrouvableCitoyen() {
  return (
    <>
      <EnTeteCitoyen titre="Page introuvable" />
      <EtatVide titre="Cette adresse ne correspond à aucune page du portail" niveau={2} action={<LienBouton href="/citoyen">Choisir une collectivité</LienBouton>} />
    </>
  );
}

export const routesCitoyen: RouteObject[] = [
  {
    path: '/citoyen',
    element: <CoquilleCitoyen />,
    children: [
      { index: true, element: <PageChoixCollectivite /> },
      { path: 'connexion', element: <PageConnexionUsager /> },
      { path: 'inscription', element: <PageInscription /> },
      { path: 'mot-de-passe', element: <PageMotDePasse /> },
      { path: 'verification', element: <PageVerification /> },
      { path: 'verification/:code', element: <PageVerification /> },
      { path: 'demarches', element: <PageCatalogue /> },
      { path: 'mes-dossiers', element: <PageMesDossiers /> },
      { path: 'mes-dossiers/:id', element: <PageDossierUsager /> },
      { path: 'mes-dossiers/:id/complement', element: <PageComplement /> },
      { path: 'mes-dossiers/:id/messages', element: <PageConversation /> },
      { path: 'messages', element: <PageMessages /> },
      // Paiements (lot L2) : créances, paiement par le prestataire (simulateur hors production), suivi, quittances, emplacements.
      { path: 'paiements', element: <PagePaiements /> },
      { path: 'paiements/creances/:id', element: <PageCreanceUsager /> },
      { path: 'paiements/suivi/:reference', element: <PageSuiviPaiement /> },
      { path: 'paiements/simulateur/:reference', element: <PageSimulateurPaiement /> },
      { path: 'paiements/historique', element: <PageMesPaiements /> },
      { path: 'paiements/quittances', element: <PageMesQuittances /> },
      { path: 'paiements/emplacements', element: <PageMesAttributions /> },
      // Signalements (lot L3-A, D-042) : dépôt avec photos et position, suivi des statuts.
      { path: 'signalements', element: <PageSignalements /> },
      { path: 'signalements/nouveau', element: <PageNouveauSignalement /> },
      { path: 'signalements/:id', element: <PageSignalementUsager /> },
      { path: 'rendez-vous', element: <PageRendezVous /> },
      { path: 'rendez-vous/nouveau', element: <PageNouveauRendezVous /> },
      // Réservations d'équipements (lot L4-A, M19) : créneaux, demande, paiement par la rubrique Paiements, suivi.
      { path: 'reservations', element: <PageMesReservations /> },
      { path: 'reservations/nouvelle', element: <PageNouvelleReservation /> },
      { path: 'reclamations', element: <PageReclamations /> },
      { path: 'reclamations/nouvelle', element: <PageNouvelleReclamation /> },
      { path: 'notifications', element: <PageNotifications /> },
      { path: 'compte', element: <PageCompte /> },
      { path: 'compte/identite', element: <PageIdentite /> },
      { path: 'compte/representations', element: <PageRepresentations /> },
      { path: 'compte/pieces', element: <PageCoffre /> },
      { path: 'quartiers', element: <PageMesQuartiers /> }, { path: 'quartiers/:id', element: <PageQuartierRepresentant /> }, // Lot L5-C1 (M17) : espace du représentant.
      { path: ':code', element: <PageAccueilCollectivite /> },
      { path: ':code/demarches', element: <PageCatalogue /> },
      { path: ':code/deliberations', element: <PageDeliberations /> }, { path: ':code/deliberations/:id', element: <PageDeliberation /> }, // Lot L5-B (M16).
      { path: ':code/consultations', element: <PageConsultations /> }, { path: ':code/consultations/:id', element: <PageConsultation /> }, { path: ':code/evenements', element: <PageEvenementsPublics /> }, // Lot L5-C1 (M17, M21).
      { path: ':code/urbanisme', element: <PageUrbanisme /> }, // Lot L5-C2 (M18).
      { path: ':code/demarches/:demarche', element: <PageFicheDemarche /> },
      { path: ':code/demarches/:demarche/deposer', element: <PageDepot /> },
      { path: '*', element: <PageIntrouvableCitoyen /> },
    ],
  },
];
